import SectionLabel from "../items/SectionLabel";
import emailjs from "emailjs-com";
import { forwardRef } from "react";

import toast, { Toaster } from "react-hot-toast";
interface IEmailForm {
  name: { value: string };
  email: { value: string };
  subject: { value: string };
  message: { value: string };
}
function ContactComponent(
  props: JSX.IntrinsicAttributes,
  ref: React.ForwardedRef<HTMLDivElement>
): JSX.Element {
  async function sendEmail(e: React.SyntheticEvent) {
    e.preventDefault();

    const target = e.target as typeof e.target & IEmailForm;

    const name = target.name.value;
    const email = target.email.value;
    const subject = target.subject.value;
    const message = target.message.value;
    /* eslint-disable camelcase */
    const params = {
      reply_to: email,
      from_name: name,
      subject: subject,
      message: message,
    };
    const loaderToastId = toast.loading("Sending...");

    const response = await emailjs.send(
      process.env.REACT_APP_EMAIL_SERVICE_ID as string,
      process.env.REACT_APP_EMAIL_TEMPLATE_ID as string,
      params,
      process.env.REACT_APP_EMAIL_USER_ID
    );
    toast.dismiss(loaderToastId);
    if (response.status === 200) {
      return toast.success("Successfully sending", { icon: "✓" });
    }
    toast.error("Something went wrong", { icon: "✗" });
  }
  return (
    <section ref={ref} {...props} className="section-container">
      <Toaster
        position="top-center"
        toastOptions={{
          className: "toaster-custom-style",
        }}
      />
      <SectionLabel title="Contact" />
      <form className="contact-form" onSubmit={sendEmail}>
        <input
          name="name"
          className="contact-input"
          placeholder="ENTER YOUR NAME*"
          type="text"
          required
        />
        <input
          name="email"
          className="contact-input"
          placeholder="ENTER YOUR EMAIL*"
          type="email"
          required
        />
        <input
          name="subject"
          className="contact-input"
          placeholder="SUBJECT"
          type="text"
        />
        <textarea
          name="message"
          className="contact-input contact-text-area"
          placeholder="YOUR MESSAGE*"
          style={{ resize: "vertical" }}
          required
        />
        <button className="btn contact-btn" type="submit">
          Submit
        </button>
      </form>
    </section>
  );
}
export const Contact = forwardRef(ContactComponent);
